import {Box, SvgIcon, SvgIconProps, Typography} from "@mui/material";
import CreditCard from "./CreditCard";
import {useTranslation} from "react-i18next";

export default function MinimumAgeCasino(props: SvgIconProps) {
    const {viewBox, ...restProps} = props;
    const {t} = useTranslation();
    
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            userSelect: 'none'
        }}>
            <Box sx={{
                borderRadius: '50%',
                backgroundColor: (theme) => theme.palette.primary.main,
                color: (theme) => theme.palette.primary.contrastText,
                height: '52px',
                width: '52px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <Typography sx={{fontSize: '20px', fontWeight: 'bold', textAlign: 'center'}}>21+</Typography>
            </Box>
            <Typography sx={{fontWeight: 'bold', textAlign: 'center', textTransform: 'uppercase', color: (theme) => theme.palette.primary.main, ml: 1}}>{t('casino')}</Typography>
        </Box>
    );
}